import { createSlice } from "@reduxjs/toolkit";
import { getCityList } from "../../reduxApi/admin/CityListReduxApi";

const citySlice = createSlice({
  name: "city",
  initialState: {
    status: "idel",
    isFiltered: false,
    city: [],
  },
  reducers: {
    setFilteredStatus: (state, action) => {
      state.isFiltered = action.payload;
    },
    deleteCityAction: (state, action) => {
      action.payload.forEach((id) => {
        const index = state.city.findIndex((item) => item.ROWID === id);
        if (index !== -1) {
          state.city.splice(index, 1);
        }
      });
    },
    updateCityAction: (state, action) => {
      const index = state.city.findIndex(
        (item) => item.ROWID === action.payload.ROWID,
      );
      if (index != -1) {
        state.city.splice(index, 1, { citys: action.payload });
      }
    },
    addCityAction: (state, action) => {
      console.log("action--->", action.payload);

      const temp = action.payload;
      console.log("temp", temp);
      temp.ROWID = action.payload.ROWID;
      console.log("temp.ROWID", temp.ROWID);

      state.city.unshift({ citys: temp }); //add new data at beginning of array
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCityList.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getCityList.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.city = action.payload.data.cities;
      });
  },
});
export const {
  deleteCityAction,
  updateCityAction,
  addCityAction,
  setFilteredStatus,
} = citySlice.actions;
export const setCityFilteredStatus = setFilteredStatus;
export default citySlice.reducer;
